import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=e1eda1cc&scoped=true&"
import script from "./TeacherList.vue?vue&type=script&lang=js&"
export * from "./TeacherList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1eda1cc",
  null
  
)

export default component.exports